import getCheggTldFrom from '../urls/getCheggTldFrom';
import { CheggTlds } from '../urls/constants';

/**
 * Utility for computing tld for client-side cookie writing
 * (note: function is implicitly tested as part of setCookie tests)
 * @param   cheggTldFrom
 * @returns
 */
export var clientComputeTldFrom = function clientComputeTldFrom(cheggTldFrom) {
  var _ref;
  return typeof window !== 'undefined' ? (_ref = cheggTldFrom !== null && cheggTldFrom !== void 0 ? cheggTldFrom : getCheggTldFrom(window.location.hostname)) !== null && _ref !== void 0 ? _ref : CheggTlds.DEFAULT : cheggTldFrom;
};
export default clientComputeTldFrom;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/cookies/clientComputeTldFrom.js
// module id = 1180
// module chunks = 11